module.exports = __webpack_public_path__ + "static/media/118-telephone.d79898e4.svg";